/**
 * Autocomplete result structure
 */
export interface AutocompleteResult {
	/**
	 * The key to be autocompleted
	 */
	invertedKey: string;

	/**
	 * The value to autocomplete
	 */
	opposite: string;
}
